import request from "@/util/http";
/**
 * 详情
 */
export function detail(params) {
	return request({
		url: '/goods/shop/doc/detail',
		method: 'get',
		params: params,
	})
}



/**
 * 列表
 */
export function list(docCategoryId) {
	return request({
		url: '/goods/shop/doc/list/' + docCategoryId,
		method: 'get',
	})
}


/**
 * 列表
 */
export function list_json(query) {
	return request({
		url: '/goods/shop/doc/list_json',
		method: 'get',
		params: query,
	})
}

/**
 * 搜索
 */
export function search(query) {
	return request({
		url: '/goods/shop/doc/search',
		method: 'get',
		params: query,
	})
}


/**
 * 搜索
 */
export function search_json(query) {
	return request({
		url: '/goods/shop/doc/search_json',
		method: 'get',
		params: query,
	})
}


/**
 * 点击数
 */
export function hits(docId) {
	return request({
		url: '/goods/shop/doc/hits/' + docId,
		method: 'get',
	})
}

// module.exports = {
// 	detail,
// 	list,
// 	list_json,
// 	search,
// 	search_json,
// 	hits,
// }
